var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallMadeDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.84961 1.16638C9.99414 1.31091 10.0664 1.47758 10.0664 1.66638C10.0664 1.85571 9.99414 2.02238 9.84961 2.16638L2.75041 9.26638H6.33361C6.52241 9.26638 6.68614 9.33598 6.82481 9.47518C6.96401 9.61385 7.03361 9.77758 7.03361 9.96638C7.03361 10.1552 6.96401 10.3192 6.82481 10.4584C6.68614 10.597 6.52241 10.6664 6.33361 10.6664H1.04961C0.860806 10.6664 0.697073 10.597 0.558406 10.4584C0.41974 10.3192 0.350406 10.1552 0.350406 9.96638V4.68318C0.350406 4.49438 0.41974 4.33065 0.558406 4.19198C0.697073 4.05278 0.860806 3.98318 1.04961 3.98318C1.23894 3.98318 1.40294 4.05278 1.54161 4.19198C1.68081 4.33065 1.75041 4.49438 1.75041 4.68318V8.28318L8.88321 1.15038C9.02774 1.00585 9.19174 0.939181 9.37521 0.950381C9.55814 0.961048 9.71627 1.03305 9.84961 1.16638Z",
    fill: "#587E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallMadeDown);
export default __webpack_public_path__ + "static/media/call_made_down.57a4a6254e87278803c0818b9f6cffc0.svg";
export { ForwardRef as ReactComponent };